import React, { useState } from "react";
import { Card, Row, Col, Badge, Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import ReprogramarProgramacion from "../Programaciones/ReprogramarProgramacion";
import { actualizarDatos, deleteById } from "../../api/common";
import { Alertassw } from "../Alertas/Alertassw";

const DetalleOT = ({ evento, setDetalleRegistro,  isOpen, setIsOpen, setRefresh }) => {

    console.log("evento registro: ", evento )
    const [showDetalle, setShowDetalle]=useState(true)
    const [viewRepogramar, setViewRepogramar]=useState(false)
  if (!evento) {
    return (
      <Card className="shadow-sm text-center p-4">
        <p className="text-muted">Selecciona un evento para ver su detalle</p>
      </Card>
    );
  }


  // Formatear fechas
  const formatDate = (date) => {
    if (!date) return "Sin fecha";
    return new Date(date).toLocaleString("es-CO", {
      weekday: "short",
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const HandleshowDetalle=()=>{
    setIsOpen(false)
  }

  const CancelarProgramacion=async(event)=>{
    try {
        const result = await Swal.fire({
          title: "¿Deseas eliminar la programación?",
          text: "Esta accion eliminara definitivamente el registro",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, Cancelar",
          cancelButtonText: "No, Volver",
        });
      
        if (result.isConfirmed) {

          await deleteById('Registro',evento.id)

          Alertassw('success','Registro eliminado correctamente')
          setRefresh(prev =>!prev )
          setIsOpen(false);

        }
      
    } catch (error) {
      console.log(error)
      Alertassw('error','No se pudo eliminar el regsitro')
      setIsOpen(false);
    }

  }
      //reporgrmar
      const onAceptar=async(data)=>{
          try {
              const result=await actualizarDatos('Registro',{
                  _id:evento.id,
                  fechaInicio:data.fechaInicio,
                  fechaFin:data.fechaCierre
              },evento.id)
              console.log(result)
              Swal.fire("Cancelada", "Se han guardado los cambios correctamente.", "success");
              setRefresh(prev=>!prev); // Refresca la lista
              setViewRepogramar(false);
              setIsOpen(false);
  
          } catch (error) {
              
              Swal.fire("Error", "Hubo un problema al reporgramar la agenda.", "error");
          }
  
      }
          const onCancelar=()=>{
              setViewRepogramar(false)
  
      }

  return (
    <>
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} show={isOpen} onHide={() => setIsOpen(false)} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Detalle del evento</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {viewRepogramar?
            <ReprogramarProgramacion onAceptar={onAceptar} onCancelar={onCancelar}/>
            : 
            <Card className="shadow-sm p-4 mx-auto" style={{ maxWidth: '700px', width: '100%' }}>
                <div className="d-flex justify-content-between align-items-center mb-3 w-100">
                    <h5 className="fw-bold mb-0 text-primary">{evento?.title}</h5>
                    <Badge bg={evento.estado === "Completado" ? "success" : "secondary"}>
                    {evento.estado || "Pendiente"}
                    </Badge>
                </div>

                <Row className="mb-2 w-100">
                    <Col md={6}>
                    <small className="text-muted fw-bold">Inicio</small>
                    <p className="mb-1">{formatDate(evento.start)}</p>
                    </Col>
                    <Col md={6}>
                    <small className="text-muted fw-bold">Fin</small>
                    <p className="mb-1">{formatDate(evento.end)}</p>
                    </Col>
                </Row>



                <Row className="mb-4 w-100">
                    <Col md={6}>
                    <small className="text-muted fw-bold">Responsable(s) </small>
                    <p className="mb-1">{evento.responsable}

                    </p>
                    </Col>
                    <Col md={6}>
                         <small className="text-muted fw-bold">Lugar</small>
                         <p className="mb-1">{evento.ubicacion}</p>
                    </Col >
                </Row>

                <div className="mb-2 w-100">
                    <small className="text-muted fw-bold">Descripción</small>
                    <p className="mb-1">{evento.descripcion || "Sin descripción"}</p>
                </div>


                <hr/>
              {/*<div className='button-controller'>
                <Button variant='warning' size='mg' className='me-2' onClick={() => setViewRepogramar(true)}>Reprogramar</Button>
                <Button variant='danger' size='mg' className='me-2' onClick={() => CancelarProgramacion(evento.id)}>Eliminar</Button>
              </div>*/}
                </Card>
                }
            </Modal.Body>
        </Modal>
    </>



  );
};

export default DetalleOT;